import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from './SvgIcon';

/**
 * @param {object} props - Props.
 * @param {string} props.providerId - ProviderId of the team you want to display
 * @param {string} [props.className] - Class(es).
 * @param {object} [props.style] - Style object.
 * @param {string} [props.theme] - An optional theme modifier e.g. '-light'
 * @returns {JSX.Element} Component.
 */
export const TeamIcon = ( { providerId, className = '', style = {}, theme } ) => {
    const teamAbbr = PULSE.app.common.team.getTeamAbbr( providerId );
    const modifier = typeof theme !== 'undefined' && theme !== '' ? `-${theme}` : '';

    return (
        <SvgIcon
            className={ className }
            icon={`aflc-${teamAbbr}${modifier}`}
            style={ style }
        />
    )
};

TeamIcon.propTypes = {
    providerId: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    theme: PropTypes.string
};

